// extracted by mini-css-extract-plugin
module.exports = {"scrollBtn":"scrollBtn_scrollBtn__1SGFn","invert":"scrollBtn_invert__2LMvI"};